import http from "../../http-common";
import BaseDocumentationService from "./baseDocumentation.service";

class DocumentModelService extends BaseDocumentationService {
  constructor() {
    super("document-template");
  }

  downloadGabarit() {
    return http.get(`${this.path}/gabarit`, {
      responseType: "blob"
    });
  }

  updateById(id, data) {
    return http.put(`${this.path}/${id}`, data);
  }

  generate(params = {}) {
    return http.get(`${this.path}/generate`, {
      headers: {
        Accept: "application/pdf"
      },
      responseType: "blob",
      params
    });
  }
}

export default new DocumentModelService();
